export function pushEvent(data, store) {
  if (data.extra_data) {
    data.extra_data.mobile_app = store.getters.inMobileApp
  } else {
    data.extra_data = { mobile_app: store.getters.inMobileApp }
  }
  try {
    $fetch('/api/logic/esp-push/', {
      method: 'POST',
      body: data,
    })
  } catch (err) {
    console.error(err)
  }
}

export function pushPageView($axios, data) {
  $axios.post('/api/logic/esp-page/', data)
}

export function getAge(dateString) {
  if (!dateString) {
    return null
  }
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const month = today.getMonth() - birthDate.getMonth()
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export function getGAIDs($cookies) {
  $cookies.get('_ga')
  let ga_client_id = null
  try {
    ga_client_id = $cookies.get('_ga').split('.').slice(-2).join('.')
  } catch {
    /** empty  */
  }

  const gaCookies = Object.fromEntries(
    Object.entries($cookies.getAll()).filter(([key, value]) =>
      key.startsWith('_ga_'),
    ),
  )

  let ga_session_id = null
  if (Object.keys(gaCookies).length === 1) {
    try {
      ga_session_id = gaCookies[Object.keys(gaCookies)[0]].split('.')[2]
    } catch {
      /** empty  */
    }
  }
  const ids = {}
  if (ga_client_id) ids.ga_client_id = ga_client_id
  if (ga_session_id) ids.ga_session_id = ga_session_id
  return ids
}

export function identifyUser($auth, $cookies) {
  if (!window?.analytics) return
  const data = getGAIDs($cookies)
  Object.assign(data, {
    name: `${$auth.user.first_name} ${$auth.user.last_name}`,
    firstName: $auth.user.first_name,
    lastName: $auth.user.last_name,
    email: $auth.user.email,
    age: getAge($auth.user.date_of_birth),
    zipcode: $auth.user.zipcode,
  })
  window.analytics.identify($auth.user.analytics_id, data)
}
